import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Tinkoff = function Tinkoff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.667h22V13.73a7.94 7.94 0 01-3.967 6.876l-7.028 4.06-7.027-4.06A7.927 7.927 0 012.01 13.73V2.667H2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.036 8.488v3.438c.474-.527 1.33-.886 2.3-.886h1.066v3.998c0 1.065-.285 1.993-.718 2.51h4.622c-.433-.517-.718-1.445-.718-2.51V11.04h1.066c.981 0 1.836.36 2.3.886V8.488H8.036z",
    fill: "#333"
  }));
};
export default Tinkoff;